import ZillowInsuranceServicesLogo from '../../ZillowInsuranceServicesLogo';
import ModalFooter from '../ModalFooter';
import { Modal } from '@zillow/constellation-10';

import RentalProtectionCoverageTableSection from '../../rentGuarantee/ProductIntroIllustrativeV2/components/RentalProtectionCoverageTableSection';
import { Paragraph } from '@zillow/constellation-10';

type Props = {
  onClose: () => void;
  onSubmit: () => void;
};

const RentalProtectionLearnMoreModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal
      open={true}
      onOpenChange={(open) => !open && onClose()}
      header={<ZillowInsuranceServicesLogo />}
      footer={<ModalFooter submitText="Ok" onSubmit={onSubmit} />}
      size={{ base: 'fullScreen', lg: 'lg' }}
      body={
        <div data-testid="RentalProtectionLearnMoreModal">
          {/* @ts-expect-error */}
          <RentalProtectionCoverageTableSection
            marginBottom={0}
            title={
              <Paragraph css={{ textStyle: 'heading-sm', marginBottom: '200', fontFamily: 'heading-alt' }}>
                Complete your landlord coverage
              </Paragraph>
            }
          />
          <Paragraph textStyle="fineprint" color="text.subtle" css={{ marginBlock: '600' }}>
            *Coverage summary based on standard dwelling fire policy and common add-ons. Information for illustrative
            purposes only. Consult your landlord property insurance policy or speak with your insurance broker for full
            details on your coverages.
          </Paragraph>
        </div>
      }
    />
  );
};

export default RentalProtectionLearnMoreModal;
